namespace TabAurous.Retail {
    export interface GiftVoucherAllocateRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        CompanyId?: number;
        CompanyName?: string;
        UserId?: number;
        EmployeeId?: number;
        ItemDetails?: GiftVoucherAllocateDetailsRow[];
    }

    export namespace GiftVoucherAllocateRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.GiftVoucherAllocate';
        export const deletePermission = 'Retail:GiftVoucherAllocation:Delete';
        export const insertPermission = 'Retail:GiftVoucherAllocation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherAllocation:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            CompanyId = "CompanyId",
            CompanyName = "CompanyName",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            ItemDetails = "ItemDetails"
        }
    }
}
